import axios from 'axios';

const MatrizService = {
  saveMatrices(payload) {
    return axios.post(`${process.env.VUE_APP_API_URL_LOCAL}/v2/matrices/save`, payload, {
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(response => {
        console.log('Matrices guardadas con éxito:', response.data);
        return response.data; // Devuelve los datos de la respuesta para que el componente los use
      })
      .catch(error => {
        console.error('Error al guardar las matrices en el backend:', error);
        throw error; // Propaga el error para manejarlo en el componente
      });
  },

  saveMatricesPractica(payload) {
    return axios.post(`${process.env.VUE_APP_API_URL_LOCAL}/v2/matrices/practica/save`, payload, {
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(response => {
        console.log('Matrices guardadas con éxito:', response.data);
        return response.data; // Devuelve los datos de la respuesta para que el componente los use
      })
      .catch(error => {
        console.error('Error al guardar las matrices en el backend:', error);
        throw error; // Propaga el error para manejarlo en el componente
      });
  },

  /** SIMCE: matrices tipo test, 30 preguntas por matriz (2 matrices → mín. 60 en unidad). */
  saveMatricesSimcePregunta(payload) {
    return axios.post(`${process.env.VUE_APP_API_URL_LOCAL}/v2/matrices/simce/pregunta/save`, payload, {
      headers: { 'Content-Type': 'application/json' }
    })
      .then(response => response.data)
      .catch(error => {
        console.error('Error matrices SIMCE (pregunta):', error);
        throw error;
      });
  },

  /** SIMCE: matrices práctica, 30 preguntas por nivel (6 niveles → mín. 180 en unidad). */
  saveMatricesSimcePractica(payload) {
    return axios.post(`${process.env.VUE_APP_API_URL_LOCAL}/v2/matrices/simce/practica/save`, payload, {
      headers: { 'Content-Type': 'application/json' }
    })
      .then(response => response.data)
      .catch(error => {
        console.error('Error matrices SIMCE (práctica):', error);
        throw error;
      });
  },

  toggleChapterVigencia(payload) {
    return axios.post(`${process.env.VUE_APP_API_URL_LOCAL}/v2/chapters/toggle-vigencia`, payload);
  },

 getNonVigentChapters() {
    return axios.get(`${process.env.VUE_APP_API_URL_LOCAL}/v2/chapters/non-vigent`);
  }

};

export default MatrizService;